import React, { useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory, Link } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from "../hooks/useDireccionEstudiantil";
import dataFinanzas from "../hooks/useFinzas";
// Contexto
import dataContext from "../context/User";
// Helper
// import SetBitacora from "../helper/SetBitacora";
import loadMenu from "../js/main";
import Footer from "../componentes/Footer";

const CanchasReservas = () => {
  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (datos) {
    let cred = JSON.parse(datos);
    dataUser.token = cred.token;
    dataUser.nombre = cred.nombre;
    dataUser.carnet = cred.carnet;

    // SetBitacora.set(cred.carnet, 'Canchas', cred.token);
  } else {
    history.push("/");
  }

  if (dataSuper.indexOf(dataUser.carnet.trim()) === -1) {
    if (
      dataDireccionEstudiantil.indexOf(dataUser.carnet.trim()) === -1 &&
      dataFinanzas.indexOf(dataUser.carnet.trim()) === -1
    ) {
      history.push("/");
    }
  }


  useEffect(() => {
    loadMenu();
  }, [dataUser.carnet]);


  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Reservar espacios deportivos</h2>
        <div className="card">
          <div className="card-body">
            <p className="text-muted mb-3">Elige el espacio que quieres reservar.</p>
            <Link className="btn btn-outline-primary btn-block" to="/canchafootballadmin">
              <i className="fa fa-futbol-o mr-2" aria-hidden="true"></i>Cancha de football
            </Link>
            <Link className="btn btn-outline-primary btn-block" to="/canchabasketballadmin">
              <i className="fa fa-trophy mr-2" aria-hidden="true"></i>Cancha de basketball
            </Link>
            <Link className="btn btn-outline-primary btn-block" to="/canchafootballsalaadmin">
              <i className="fa fa-futbol-o mr-2" aria-hidden="true"></i>Cancha de football sala
            </Link>
            <Link className="btn btn-outline-primary btn-block" to="/canchavoleiboladmin">
              <i className="fa fa-trophy mr-2" aria-hidden="true"></i>Cancha de voleibol
            </Link>
            {/* <Link className="btn btn-outline-primary btn-block" to="/canchapp1">
               Tenis de mesa 1
            </Link>
            <Link className="btn btn-outline-primary btn-block" to="/canchapp2">
               Tenis de mesa 2
            </Link> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CanchasReservas;
